import React, { useContext, useRef } from 'react'
import styles from './ExperienceYears.module.css'
import { ChoicesButton } from '../../../Common/CtaButton/ChoicesButton'
import { StepContext } from '@/components/Context/StepContext'
import { StepBadge } from '@/components/Common/StepBadge'
import { useAbTestGtm } from '@/components/utils/abTest'
import { FollowIcon } from '../../../FormGuidance/FollowIcon'
import { useFollowIcon } from '../../../FormGuidance/FollowIcon/useFollowIcon'
import { ExperienceYearsProps } from './types'

const BASE = '/entry_form_slide_app/steps/vertical_step2'

// 縦型EF step2(経験年数)
export const ExperienceYearsVertical = ({ gtmTags, stepNumber }: ExperienceYearsProps) => {
    const { handleNext, updateFormData, formData, isCurrentStepValid, isAnimating, currentStep } = useContext(StepContext)

    const parentRef = useRef<HTMLDivElement>(null)
    const questionRef = useRef<HTMLDivElement>(null)
    const selectionRef = useRef<HTMLDivElement>(null)
    const targets = [
        { ref: questionRef, isComplete: false },
        { ref: selectionRef, isComplete: isCurrentStepValid },
    ]
    const { iconStyle } = useFollowIcon({ parentRef, targets, isAnimating, layoutKey: currentStep })

    const handleSelect = (years: string) => {
        updateFormData('experienceYears', years)
        // DEV-3061: フロンティアstepのみ遷移
        if (currentStep === stepNumber - 1) {
            handleNext()
        }
    }

    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    const options = [
        { value: '1年未満', img: 'one-year', label: '1年未満', click: gtmTags.dataClickLabels.lessThan1 },
        { value: '1~5年', img: 'five-year', label: '1~5年', click: gtmTags.dataClickLabels.oneToFive },
        { value: '5~10年', img: 'ten-year', label: '5~10年', click: gtmTags.dataClickLabels.fiveToTen },
        { value: '10年以上', img: 'more-ten-year', label: '10年以上', click: gtmTags.dataClickLabels.moreThan10 },
    ]

    return (
        <div className={styles.wrapper} ref={parentRef} data-view-label={dataViewLabel(gtmTags.dataViewLabel)}>
            <FollowIcon iconStyle={iconStyle} />
            <div className={styles.title} ref={questionRef}>
                <h2 className={styles.titleText}>
                    <StepBadge number={stepNumber} />飲食業界の経験年数は？
                </h2>
            </div>
            <div className={styles.selectionWrapper} ref={selectionRef}>
                {options.map((opt) => {
                    // このselectedは画像パスのon/off切替にのみ使う
                    const selected = formData.experienceYears === opt.value
                    return (
                        // 選択状態は画像の差し替えで表現するため、ChoicesButtonの
                        // selectedは渡さない（既定値false＝.selectedの背景色#FFE7B7を付けない）
                        <ChoicesButton
                            key={opt.value}
                            imageSrc={`${BASE}/${opt.img}_${selected ? 'on' : 'off'}.png`}
                            imageAlt={opt.label}
                            dataClickLabel={dataClickLabel(opt.click)}
                            onClick={() => handleSelect(opt.value)}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default ExperienceYearsVertical
